import { IMember, INewUser } from "@wingspanhq/users/dist/lib/interfaces";

import { getProfileDataAddress } from "../FormPartialAddress";

import { getPersonFormEmptyValues } from "./emptyValues";

import { FormPartialDataPerson, FormPartialPersonType } from ".";
import type { userApiSpec } from "@wingspanhq/wingspan-api-types";

export function getProfileDataPerson(props: {
  type: FormPartialPersonType;
  user?: INewUser;
  member?: IMember;
  userV2?: userApiSpec.UserProfileResponse;
}): Partial<FormPartialDataPerson> {
  const { type, userV2, user, member } = props;

  if (type === "BeneficialOwner") {
    return {};
  }

  const profileAddress = getProfileDataAddress(member, {
    homeAddress: type === "Representative"
  });

  return {
    address: { ...getPersonFormEmptyValues().address, ...profileAddress },
    birthday: user?.profile.dob,
    country: member?.profile.address?.country || "US",
    firstName: user?.profile.firstName,
    lastName: user?.profile.lastName,
    middleName: user?.profile.middleName,
    jobTitle: userV2?.profile?.individual?.occupation
  };
}
